// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__J1u8P"};